import React from 'react';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';

import type { Document } from '../../../../common/types/client';

type Props = {
  document: Document;
};

function DocumentRow({ document }: Props) {
  return (
    <Stack flex={1} direction='row' spacing={2} justifyContent='flex-start' alignItems='center'>
      <Link href={document.link} target='_blank'>
        {document.name}
      </Link>
    </Stack>
  );
}

export default DocumentRow;
